var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"btn details_btn mr-2",on:{"click":_vm.reAssignPOSModal}},[_vm._v("\n    "+_vm._s(_vm.$t("text.clickButtons.reAssignPos"))+"\n  ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{
      name: 'company-pos-terminals-details',
      query: { terminalId: _vm.data.id, companyId:_vm.data.companyId},
    }}},[_c('button',{staticClass:"btn details_btn"},[_vm._v("View Details")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }